<template>
  <div class="play-time-limit-form">
    <a-spin :spinning="loading">
      <h3 class="title">
        <font-awesome-icon :icon="['far', 'calendar-days']" class="anticon" />
        {{ labels.title2 }}
      </h3>
      <span class="subtitle">
        {{ labels.subtitle }}
      </span>
      <ValidationObserver ref="observerPlayTimeLimit">
        <a-form
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(onSubmit)"
        >
          <!-- Form fields go here -->
          <a-row :gutter="16">
            <a-col :xs="24" :sm="24" :md="12">
              <Input
                type="number"
                v-model="form.dailyLimit"
                rules="required"
                vid="dailyLimit"
                :placeholder="labels.form.dailyLimit.placeholder"
                size="large"
                :allowClear="true"
                :label="labels.form.dailyLimit.label"
                :step="1"
                :min="1"
              />
            </a-col>
            <a-col :xs="24" :sm="24" :md="12">
              <Input
                type="number"
                v-model="form.weeklyLimit"
                rules="required"
                vid="weeklyLimit"
                :placeholder="labels.form.weeklyLimit.placeholder"
                size="large"
                :allowClear="true"
                :label="labels.form.weeklyLimit.label"
                :step="1"
                :min="1"
              />
            </a-col>
            <a-col :xs="24" :sm="24" :md="12">
              <Input
                type="number"
                v-model="form.monthlyLimit"
                rules="required"
                vid="monthlyLimit"
                :placeholder="labels.form.monthlyLimit.placeholder"
                size="large"
                :allowClear="true"
                :label="labels.form.monthlyLimit.label"
                :step="1"
                :min="1"
              />
            </a-col>
          </a-row>
          <a-form-item>
            <a-button
              type="primary"
              size="large"
              @click="validate().then(onSubmit)"
            >
              {{ labels.form.save }}
            </a-button>
          </a-form-item>
        </a-form>
      </ValidationObserver>
    </a-spin>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import _ from "lodash";
import { mapActions } from "vuex";
import Input from "@/components/core/VeeValidateForm/Input.vue";

const defaultState = {
  dailyLimit: null,
  weeklyLimit: null,
  monthlyLimit: null,
};

export default {
  name: "PlayAmountLimitForm",
  components: {
    ValidationObserver,
    Input,
  },
  props: {
    labels: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: _.cloneDeep(defaultState),
      submitting: false,
      loading: false,
    };
  },
  created() {
    this.handleGetLimits();
  },
  methods: {
    ...mapActions("responsibleGaming", ["setLimits", "getLimits"]),
    async handleGetLimits() {
      try {
        this.loading = true;
        const limits = await this.getLimits();
        if (!limits) return;
        this.form.dailyLimit = limits.dailyLimit;
        this.form.weeklyLimit = limits.weeklyLimit;
        this.form.monthlyLimit = limits.monthlyLimit;
      } catch (error) {
        this.$notification["error"]({
          message:
            error?.response?.data?.message ||
            error?.response?.message ||
            error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async onSubmit() {
      if (this.submitting) return;
      try {
        this.submitting = true;
        await this.setLimits({
          ...this.form,
        });

        this.$success({
          class: "success-modal",
          title: this.labels.success,
          centered: true,
          width: this.isMobile ? "100%" : "600px",
        });
      } catch (error) {
        if (error.isAxiosError && error.response.status === 400) {
          this.$notification["error"]({
            message: error.response?.data?.message || error.response?.message,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.length
                  ? error.response?.data?.additional_errors?.map((error) => {
                      return h("li", error);
                    })
                  : h("li", error.response?.data?.message)
              );
            },
          });
        } else {
          this.$notification["error"]({
            message:
              error?.response?.data?.message ||
              error?.response?.message ||
              error.message,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.play-time-limit-form {
  .title {
    border-bottom: 1px solid var(--border-color);
    color: var(--text);
  }
  .subtitle {
    display: block;
    margin-bottom: 24px;
    color: var(--text);
  }
}
</style>
